import service from './axios';

export const getMemberUsers = (params = {}) => service.get('/manage/user-list', { params });
export const getMemberUser = (id) => service.get(`/manage/user-list/${id}`);
export const getUserConsumptions = (id) => service.get(`/manage/user-list/${id}/consumptions`);
export const updateMemberLevel = (id, level) => service.put(`/manage/users/${id}/member-level`, { member_level: level });
export const rechargeBalance = (id, amount, remark) => service.put(`/manage/users/${id}/recharge`, { amount, remark });
